<template>
  <sh-table condensed="true">
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2">FL under Contract</sh-text></sh-table-cell
      >

      <sh-table-cell columns="13" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Avg. Wallclock </sh-text>
        <sh-text size="body-2">
          <span class="legendlabellow">low</span> to
          <span class="legendlabelhigh">high</span>
        </sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <span style="opacity: 0.9" class="gradientborder"></span>
      </sh-table-cell>
    </sh-table-row>

    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2">FL not under Contract</sh-text></sh-table-cell
      >

      <sh-table-cell columns="13" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Avg. Wallclock </sh-text>
        <sh-text size="body-2">
          <span class="legendlabellow">low</span> to
          <span class="legendlabelhigh">high</span>
        </sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <span style="opacity: 0.9" class="gradient"></span>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2">CSE</sh-text></sh-table-cell
      >

      <sh-table-cell
        columns="13"
        style="text-align: left; vertical-align: middle !important"
        ><sh-text size="body-2"
          >Utilization (6 months) &lt; 33</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <span style="opacity: 0.7" class="equilateralTriangleLow"></span>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"></sh-table-cell>

      <sh-table-cell columns="13" style="text-align: left"
        ><sh-text size="body-2"
          >Utilization (6 months) [33,85]</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <span style="opacity: 0.7" class="equilateralTriangleMed"></span>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"></sh-table-cell>
      <sh-table-cell columns="13" style="text-align: left"
        ><sh-text size="body-2"
          >Utilization (6 months) &gt; 85</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <span style="opacity: 0.7" class="equilateralTriangleHigh"></span>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2">CSA</sh-text></sh-table-cell
      >

      <sh-table-cell
        columns="13"
        style="text-align: left; vertical-align: middle !important"
        ><sh-text size="body-2"
          >Utilization (6 months) &lt; 33</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <div style="opacity: 0.7" class="squareCSALow"></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>

      <sh-table-cell
        columns="13"
        style="text-align: left; vertical-align: middle !important"
        ><sh-text size="body-2"
          >Utilization (6 months) [33,85]</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <div style="opacity: 0.7" class="squareCSAMed"></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="7" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>

      <sh-table-cell
        columns="13"
        style="text-align: left; vertical-align: middle !important"
        ><sh-text size="body-2"
          >Utilization (6 months) &gt; 85</sh-text
        ></sh-table-cell
      >
      <sh-table-cell columns="4">
        <div style="opacity: 0.7" class="squareCSAHigh"></div>
      </sh-table-cell>
    </sh-table-row>
  </sh-table>
</template>

<script>
export default {
  name: "MapLegend",
  components: {},
  props: [],
  data() {
    return {};
  },
  mounted() {},
  created() {},
  beforeUnmount() {
    console.log("MapLegend component destroyed!");
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped lang="scss">
.legendlabellow {
  color: #087035;
  font-weight: bold;
}

.legendlabelhigh {
  color: #d73027;
  font-weight: bold;
}

.gradient {
  height: 20px;
  width: 40px;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    #087035,
    #1a9850,
    #66bd63,
    #a6d96a,
    #d9ef8b,
    #ffff64,
    #fedf8b,
    #fdae61,
    #f46c43,
    #d73027
  );
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(-25%, -50%);
}

.gradientborder {
  height: 20px;
  width: 40px;
  margin: 0;
  position: absolute;
  border: double 3px transparent;
  border-radius: 30px;
  background-image: linear-gradient(
      to right,
      #087035,
      #1a9850,
      #66bd63,
      #a6d96a,
      #d9ef8b,
      #ffff64,
      #fedf8b,
      #fdae61,
      #f46c43,
      #d73027
    ),
    linear-gradient(
      to left,
      #96211b,
      #aa4b2e,
      #b17943,
      #b19c61,
      #b2b246,
      #97a761,
      #74974a,
      #478445,
      #126a38,
      #054e25
    );
  background-origin: border-box;
  background-clip: content-box, border-box;
  top: 50%;
  transform: translate(-25%, -50%);
}

.equilateralTriangleLow {
  --a: 1.5em;
  border-bottom: calc(0.866 * var(--a)) solid #0000bf;
  border-left: calc(var(--a) / 2) solid transparent;
  border-right: calc(var(--a) / 2) solid transparent;
  border-top: 0;
  height: 0;
  width: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.equilateralTriangleMed {
  --a: 1.5em;
  border-bottom: calc(0.866 * var(--a)) solid #007d00;
  border-left: calc(var(--a) / 2) solid transparent;
  border-right: calc(var(--a) / 2) solid transparent;
  border-top: 0;
  height: 0;
  width: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.equilateralTriangleHigh {
  --a: 1.5em;
  border-bottom: calc(0.866 * var(--a)) solid #bf0000;
  border-left: calc(var(--a) / 2) solid transparent;
  border-right: calc(var(--a) / 2) solid transparent;
  border-top: 0;
  height: 0;
  width: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.squareCSALow {
  height: 20px;
  width: 20px;
  background-color: #0000bf;
  margin: 0;
}
.squareCSAMed {
  height: 20px;
  width: 20px;
  background-color: #007d00;
  margin: 0;
}
.squareCSAHigh {
  height: 20px;
  width: 20px;
  background-color: #bf0000;
  margin: 0;
}
</style>
